"use client";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useAnalytics } from "@travel/shared/data-access";
import { BaseLink } from "./base-link";
export function Link(_a) {
    var _b = _a.track, _c = _b === void 0 ? { name: "" } : _b, name = _c.name, data = _c.data, onClick = _a.onClick, rest = __rest(_a, ["track", "onClick"]);
    var track = useAnalytics().track;
    return _jsx(BaseLink, __assign({}, rest, { onClick: handleOnClick }));
    function handleOnClick(event) {
        if (name) {
            track("".concat(name, ":click"), data);
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    }
}
